<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Data Analysis/ ລາຍງານລວມ
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" >
        <b-tab-item label="ລາຍງານລວມ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍງານລວມ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="20%">#</th>
                      <th class="has-text-left " width="60%">
                        ລາຍງານ
                      </th>
                      <th class="has-text-left " width="20%">
                        ລາຍລະອຽດ
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in reportTYPE" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.NAME }}
                      </td>
                     

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                reportDetail(data.ID, data.NAME)
                              "
                              >ລາຍລະອຽດ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ລາຍລະອຽດ">
          <div class="columns">
            <div class="column">
              <table width="100%" class="table " v-if="selectedReportTypeID==1">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="5%">
                      #
                    </th>
                    <th class="has-text-centered " width="50%">
                      ແຂວງ
                    </th>
                    <th class="has-text-centered " width="30%">
                      ຈຳນວນສັນຍາ
                    </th>
                    <th class="has-text-centered " width="30%">
                      ຈຳນວນສິນຄ້າທີ່ຜະລິດ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in reportDetailList"
                    :key="data.ID"
                  >
                    <td
                      class="has-text-centered"
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      class="has-text-centered"
                    >
                      {{data.PROVINCENAME}}
                    </td>
                    <td
                      class="has-text-centered"
                    >
                      {{data.NUMOFCONTRACT}}
                    </td>
                    <td
                      class="has-text-centered"
                    >
                      {{data.NUMOFPRODUCT}}
                    </td>
                   
             
                  </tr>
                </tbody>
              </table>

              <table width="100%" class="table " v-if="selectedReportTypeID==2">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="5%">
                      #
                    </th>
                    <th class="has-text-centered " width="50%">
                      ແຂວງ
                    </th>
                    <th class="has-text-centered " width="30%">
                      ຈຳນວນຟາມ/ຊາວກະສິກອນ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in reportDetailList"
                    :key="data.ID"
                  >
                    <td
                      class="has-text-centered"
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      class="has-text-centered"
                    >
                      {{data.PROVINCENAME}}
                    </td>
                    <td
                      class="has-text-centered"
                    >
                      {{data.NUMOFFARM}}
                    </td>
                   
             
                  </tr>
                </tbody>
              </table>

              <table width="100%" class="table " v-if="selectedReportTypeID==3">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="5%">
                      #
                    </th>
                    <th class="has-text-centered " width="40%">
                      ຕະຫຼາດ
                    </th>
                    <th class="has-text-right " width="20%">
                      ຈຳນວນ Order
                    </th>
                    <th class="has-text-right " width="20%">
                      ຈຳນວນ Rider
                    </th>
                    <th class="has-text-right " width="30%">
                       ຍອດລວມ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in reportDetailList"
                    :key="data.ID"
                  >
                    <td
                      class="has-text-centered"
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      class="has-text-centered"
                    >
                      {{data.NAME}}
                    </td>
                    <td
                      class="has-text-right"
                    >
                      {{data.NUMOFORDER | formatNumberLocal}}
                    </td>
                     <td
                      class="has-text-right"
                    >
                      {{data.NUMOFRIDER | formatNumberLocal}}
                    </td>
                    <td
                      class="has-text-right" 
                    >
                      {{data.AMOUNT | formatNumberLocal}}
                    </td>
                   
             
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="2" class="has-text-centered">
                      ລວມ {{ reportDetailList.length | formatNumberLocal }} ລາຍການ
                    </th>
                    <th class="has-text-right">
                      {{ _.sumBy(reportDetailList, i => i["NUMOFORDER"] * 1) | formatNumberLocal }}
                    </th>
                    <th class="has-text-right">
                      {{ _.sumBy(reportDetailList, i => i["NUMOFRIDER"] * 1) | formatNumberLocal }} 
                    </th>
                    <th class="has-text-right">
                      {{ _.sumBy(reportDetailList, i => i["AMOUNT"] * 1) | formatNumberLocal }}
                    </th>
                    
                  </tr>
                </tfoot>
              </table>
              <table width="100%" class="table " v-if="selectedReportTypeID==4">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="5%">
                      #
                    </th>
                    <th class="has-text-centered " width="40%">
                      ສາງ
                    </th>
                    <th class="has-text-right " width="20%">
                      ຈຳນວນຜ່ານສາງ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in reportDetailList"
                    :key="data.ID"
                  >
                    <td
                      class="has-text-centered"
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      class="has-text-centered"
                    >
                      {{data.NAME}}
                    </td>
                    <td
                      class="has-text-right"
                    >
                      {{data.QUANTITY}}
                    </td>
                   
             
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="2" class="has-text-centered">
                      ລວມ {{ reportDetailList.length | formatNumberLocal }} ລາຍການ
                    </th>
                    <th class="has-text-right">
                      {{ _.sumBy(reportDetailList, i => i["QUANTITY"] * 1) | formatNumberLocal }}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </b-tab-item>

        
        
        
      </b-tabs>
    </div>

    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import moment from "moment";

export default {
  data() {
    return {
      userName: null,
      roleid: null,
      marketlist: [],
      inactivemarkets: [],
      marketid: null,
      marketname: null,

      reportTYPE: [{"ID":"1", "NAME":"ລາຍງານຜະລິດຕາມສັນຍາ"},
                     {"ID":"2", "NAME":"ລາຍງານຊາວກະສິກອນ"},
                     {"ID":"3", "NAME":"ລາຍການຂາຍ ຕະຫຼາດ"},
                     {"ID":"4", "NAME":"ລາຍງານສາງເກັບສິນຄ້າ"},
              ],

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      orderlist: [],
      orderdertaillist: [],

      preparelist: [],
      combineorder: [],
      combineorderdetail: [],

      completepreparelist: [],
      completecombineorder: [],
      completecombineorderdetail: [],

      prepareidforprint: [],
      combineorderforprint: [],
      combineorderdetailforprint: [],

      selectedReportTypeID: null,
      selectedReportTypeNAME: null,
      reportDetailList: [],
    };
  },
  methods: {
    getMarkets() {
      RestAPI.getAllReport()
        .then((res) => {
          // console.log("list:" + JSON.stringify(res.data));
          this.marketlist = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    reportDetail(ID, NAME){
      this.activeTab = 1;
      this.selectedReportTypeID =ID;
      this.selectedReportTypeNAME = NAME;

        RestAPI.reportDetail(ID)
        .then((res) => {
          this.reportDetailList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
   
      
    },



    gotomarketlist() {
      this.activeTab = 0;
    },
    openOderlistTab(ID, NAME) {
      this.getMarketOnlineOrder(ID);
      this.marketid = ID;
      this.marketname = NAME;
      this.activeTab = 1;
      this.clearPrintdata();
    },
    getMarketOnlineOrder(marketid) {
      RestAPI.getMarketOnlineOrder(marketid)
        .then((res) => {
          // console.log("res.data.order: "+ JSON.stringify(res.data.order))
          this.orderlist = res.data.order;
          this.orderdertaillist = res.data.orderdetail;
          this.getMarketOnlineOrderDetail();
          this.getMarketOnlineOrderCompleteDetail();
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    combineOrders() {
      var params = {
        orderlist: this.orderlist,
        marketid: this.marketid,
        username: this.username,
      };

      RestAPI.combineOrders(params)
        .then(() => {
          // console.log("res:" + JSON.stringify(res.data))
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          this.getMarketOnlineOrder(this.marketid);
          this.getMarketOnlineOrderDetail();
          this.activeTab = 2;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    completeCombineOrders(prepareid) {
      var params = {
        prepareid: prepareid,
        username: this.username,
      };

      RestAPI.completeCombineOrders(params)
        .then(() => {
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          this.getMarketOnlineOrder(this.marketid);
          this.getMarketOnlineOrderDetail();
          this.getMarketOnlineOrderCompleteDetail();
          this.activeTab = 2;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    cancelCombineOrders(prepareid) {
      var params = {
        prepareid: prepareid,
        username: this.username,
      };

      RestAPI.cancelCombineOrders(params)
        .then(() => {
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          this.getMarketOnlineOrder(this.marketid);
          this.getMarketOnlineOrderDetail();
          this.activeTab = 2;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    cancelCombineOrdersForever(prepareid) {
      this.$swal({
        title: "ຕ້ອງການຍົກເລີກລາຍການຖາວອນ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            prepareid: prepareid,
            username: this.username,
          };

          RestAPI.cancelCombineOrdersForever(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.getMarketOnlineOrder(this.marketid);
              this.getMarketOnlineOrderDetail();
              this.activeTab = 2;
              this.clearPrintdata();
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    getMarketOnlineOrderDetail() {
      RestAPI.getMarketOnlineOrderDetail(this.marketid)
        .then((res) => {
          // console.log("marketid: " + this.marketid)
          // console.log("getMarketOnlineOrderDetail: " + JSON.stringify(res.data))
          this.preparelist = res.data.prepare;
          this.combineorder = res.data.combineorder;
          this.combineorderdetail = res.data.combineorderdetail;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getMarketOnlineOrderCompleteDetail() {
      RestAPI.getMarketOnlineOrderCompleteDetail(this.marketid)
        .then((res) => {
          // console.log("marketid: " + this.marketid)
          // console.log("getMarketOnlineOrderDetail: " + JSON.stringify(res.data))
          this.completepreparelist = res.data.prepare;
          this.completecombineorder = res.data.combineorder;
          this.completecombineorderdetail = res.data.combineorderdetail;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getMarketOnlineOrderDetailbyPrepareid(prepareid) {
      RestAPI.getMarketOnlineOrderDetailbyPrepareid(prepareid)
        .then((res) => {
          // console.log("res.data.combineorderdetail: " + JSON.stringify(res.data.combineorderdetail))
          this.activeTab = 4;
          this.prepareidforprint = res.data.prepare;
          this.combineorderforprint = res.data.combineorder;
          this.combineorderdetailforprint = res.data.combineorderdetail;
          // console.log("prepareidforprint: " +  this.prepareidforprint)
          // this.print();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    clearPrintdata() {
      this.prepareidforprint = [];
      this.combineorderforprint = [];
      this.combineorderdetailforprint = [];
    },

    printReceipt(prepareid) {
      this.getMarketOnlineOrderDetailbyPrepareid(prepareid);
    },

    print() {
      window.print();
    },
  },
  mounted() {
    // console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID
      ? this.user.BRANCHPROVNICEID
      : "all";
    this.getMarkets();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.very-important-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 40px;
}

/* .paymentdetailselected {
  margin-top: 5px;
  margin-bottom: 5px;
}
.paymentdetailselectedhightlight {
  font-weight: bold;
} */

.print-receipt {
  font-size: 10px;
}
.print-receipt-titel {
  font-size: 12px;
}
.print_table {
  font-size: 10px;
}
.print_tr {
  padding: 0px 0px 0px 0px;
}
.print_td {
  padding: 0px 0px 0px 0px !important;
  margin: 0px 0px 0px 0px !important;
  /* font-size: 20px; */
}
@media all {
  .page-break {
    display: none;
  }
}
@media print {
  @page {
    margin: -10px 0px 0px 0px !important;
    padding: -10px 0px 0px 0px !important;
    size: portrait;
  }
  .page-break {
    display: block;
    max-width: 99%;
  }
}
</style>
